import styled from 'styled-components';

export const ErrorWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
`;

export const ErrorContent = styled.div`
    width: 320px;
`;
